var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventEmitter } from '@angular/core';
import { DRIVE_ENTRY_FULL_PERMISSIONS } from '../../permissions/drive-entry-permissions';
var SharingPermissionsButtonComponent = /** @class */ (function () {
    function SharingPermissionsButtonComponent() {
        this.permissions = DRIVE_ENTRY_FULL_PERMISSIONS;
        this.change = new EventEmitter();
        this.compact = false;
    }
    SharingPermissionsButtonComponent.prototype.overallPermission = function () {
        if (this.permissions.varies) {
            return 'varies';
        }
        else if (this.permissions.edit) {
            return 'edit';
        }
        else if (this.permissions.download) {
            return 'download';
        }
        {
            return 'view';
        }
    };
    SharingPermissionsButtonComponent.prototype.selectPermission = function (permission) {
        if (permission === 'edit') {
            this.permissions = __assign({}, DRIVE_ENTRY_FULL_PERMISSIONS);
        }
        else if (permission === 'download') {
            this.permissions = __assign({}, DRIVE_ENTRY_FULL_PERMISSIONS, { edit: false });
        }
        else {
            this.permissions = __assign({}, DRIVE_ENTRY_FULL_PERMISSIONS, { edit: false, download: false });
        }
        this.change.emit(this.permissions);
    };
    return SharingPermissionsButtonComponent;
}());
export { SharingPermissionsButtonComponent };
